export type QualityMode = 'High' | 'Medium' | 'Mobile';

export interface QualitySettings {
  mode: QualityMode;
  pixelRatio: number;
  shadowSize: number;
  tubeSegments: number;
  particles: number;
}

export function detectQuality(): QualitySettings {
  const mobile = matchMedia('(pointer: coarse)').matches || innerWidth < 760;
  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 8;
  if (mobile) return { mode: 'Mobile', pixelRatio: Math.min(devicePixelRatio, 1.25), shadowSize: 512, tubeSegments: 18, particles: 7 };
  if (memory <= 4 || devicePixelRatio > 2) return { mode: 'Medium', pixelRatio: Math.min(devicePixelRatio, 1.6), shadowSize: 1024, tubeSegments: 26, particles: 11 };
  return { mode: 'High', pixelRatio: Math.min(devicePixelRatio, 2), shadowSize: 2048, tubeSegments: 40, particles: 16 };
}
